import { createSlice } from "@reduxjs/toolkit";

const initialAuditReasonsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [],
  auditreasonscreate: [], 
  auditreasonsdelete: [], 
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const AuditReasonsSlice = createSlice({

  name: "auditReasons",
  initialState: initialAuditReasonsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },

    auditReasonsList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    auditReasonsCreate: (state, action) => {
      const { auditreasonscreate } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      // state.entities = entities;
      state.auditreasonscreate = auditreasonscreate;
    },
    auditReasonsDelete: (state, action) => {
      const { auditreasonsdelete } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      // state.entities = entities;
      state.auditreasonsdelete = auditreasonsdelete;
    },
    auditReasonsExport: (state, action) => {
      const { exportData } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.exportData = exportData;
    },
  }
});
